import axios from "axios";
import { baseDomain } from "../../../../../Constants/apiRoutes";

const BASE_URL_V1 = `${baseDomain}/v2`;


export const createSectionItemApi = (data) => {
  return axios.post(`${BASE_URL_V1}/sectionItem`, data);
};

export const updateSectionItemApi = (id, data) => {
  return axios.put(`${BASE_URL_V1}/sectionItem/${id}`, data);
};

export const getSectionItemByIdApi = (id) => {
  return axios.get(`${BASE_URL_V1}/sectionItem/${id}`);
};

export const getAllSectionItemsApi = (page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V1}/sectionItem?page=${page}&limit=${limit}`);
};

export const getSectionItemBinApi = (page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V1}/sectionItem/bin/list?page=${page}&limit=${limit}`);
};

export const deleteSectionItemApi = (id) => {
  return axios.delete(`${BASE_URL_V1}/sectionItem/${id}`);
};

export const restoreSectionItemApi = (id) => {
  return axios.put(`${BASE_URL_V1}/sectionItem/restore/${id}`);
};

export const searchMediaApi = (searchKey = "", page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V1}/sectionItem/media/list?searchKey=${searchKey}&page=${page}&limit=${limit}`);
};
